import React, { useState } from "react";
import {
  Box,
  Typography,
  Checkbox,
  Radio,
  FormControlLabel,
  Button,
  useTheme,
} from "@mui/material";
import StarIcon from "@mui/icons-material/Star";
import CommonLabel from "./label";
import theme from "../theme";

const FilterSection = ({
  title,
  options = [],
  selectedValues = [],
  onChange,
  showLoadMore = false,
  initialVisibleCount = 6,
  type = "default", // "default" | "rating"
}) => {
  const [showAll, setShowAll] = useState(false);    
  const theme = useTheme();
  const visibleOptions =
    showLoadMore && !showAll
      ? options.slice(0, initialVisibleCount)
      : options;

  const handleCheckboxChange = (value) => {
    if (type === "radio") {
      const updatedValues = value;
      onChange?.(updatedValues);
      return;
    }

    const updatedValues = selectedValues.includes(value)
      ? selectedValues.filter((item) => item !== value)
      : [...selectedValues, value];

    onChange?.(updatedValues);
  };

  return (
    <Box sx={{ mb: 4 }}>
      <CommonLabel
        variant="body2"
        sx={{
          fontWeight: 500,
          color: "#666",
          textTransform: "uppercase",
          mb: 1.5,
          letterSpacing: "0.4px",
        }}
      >
        {title}
      </CommonLabel>

      <Box sx={{ display: "flex", flexDirection: "column", gap: 0.5 }}>
        {visibleOptions.map((option, index) => {
          const label =
            typeof option === "string" ? option : option.label || option.value;
          const value =
            typeof option === "string" ? option : option.value || option.label;

          return (
            <FormControlLabel
              key={`${value}-${index}`}
              control={
                type === "radio" ? (
                  <Radio
                    checked={selectedValues === value}
                    onChange={() => handleCheckboxChange(value)}
                    sx={{
                      color: "#e6e6e6",
                      "&.Mui-checked": {
                        color: "#ff4f93",
                      },
                      p: 0.5,
                      mr: 1,
                    }}
                    size="small"
                  />
                ) : (
                  <Checkbox
                    checked={selectedValues.includes(value)}
                    onChange={() => handleCheckboxChange(value)}
                    sx={{
                      color: "#e6e6e6",
                      "&.Mui-checked": {
                        color: "#ff4f93",
                      },
                      p: 0.5,
                      mr: 1,
                    }}
                  />
                )
              }
              label={
                type === "rating" ? (
                  <Box sx={{ display: "flex", alignItems: "center", gap: 0.8 }}>
                    <StarIcon sx={{ fontSize: 18, color: "#f4c400" }} />
                    <Typography sx={{ fontSize: "1rem", color: "#333" }}>
                      {label}
                    </Typography>
                  </Box>
                ) : (
                  <Typography sx={{ fontSize: "1rem", color: "#333" }}>
                    {label}
                  </Typography>
                )
              }
              sx={{
                m: 0,
                alignItems: "center",
              }}
            />
          );
        })}
      </Box>

      {showLoadMore && options.length > initialVisibleCount && !showAll && (
        <Button
          variant="text"
          onClick={() => setShowAll(true)}
          sx={{
            mt: 1,
            p: 0,
            minWidth: "auto",
            textTransform: "none",
            color: "#ff4f93",
            fontWeight: 500,
            justifyContent: "flex-start",
            "&:hover": {
              background: "transparent",
              color: "#ff2f7d",
            },
          }}
        >
          + Load More
        </Button>
      )}
    </Box>
  );
};

const CommonFilterBox = ({ title = "Filters", sections = [], onFilterChange }) => {
  const [selectedFilters, setSelectedFilters] = useState({});

  const handleSectionChange = (sectionKey, values) => {
    const updatedFilters = {
      ...selectedFilters,
      [sectionKey]: values,
    };

    setSelectedFilters(updatedFilters);
    onFilterChange?.(updatedFilters);
  };

  return (
    <Box
      sx={{
        width: "100%",
        maxWidth: 320,
        paddingRight: 3,
        // backgroundColor: "#f7f7f7",
        // borderRadius: 2,
        borderRight:'1px solid #e0e0e0'

      }}
    >
        <Box sx={{display:'flex',justifyContent:'space-between',alignItems:'center'}}> 

      <CommonLabel
        variant="h5"
        sx={{
            fontWeight: 700,
            color: "#111",
            mb: 4,
        }}
        >
        {title}
      </CommonLabel>
      <CommonLabel
        variant="caption"
        sx={{
            fontWeight: 700,
            color: theme.typography.colorGrey,
            mb: 4,

        }}
        >
        Clear
      </CommonLabel>

          </Box>

      {sections.map((section, index) => (
        <FilterSection
          key={section.key || index}
          title={section.header}
          options={section.values}
          selectedValues={selectedFilters[section.key] || []}
          onChange={(values) => handleSectionChange(section.key, values)}
          showLoadMore={section.showLoadMore}
          initialVisibleCount={section.initialVisibleCount || 6}
          type={section.type || "default"}
        />
      ))}
    </Box>
  );
};

export default CommonFilterBox;